import { FormControlLabel, Switch } from "@mui/material";
import React, { useMemo } from "react";

const parseParam = (value: any) => {
  if (!value) return [];

  if (typeof value === "string") {
    return JSON.parse(value);
  }

  return value;
};

const AdditionalSelector: React.FC<{
  onChange: () => void;
  additionalInfos: any;
  httpParams: any;
}> = ({ onChange, additionalInfos, httpParams }) => {
  const checked = useMemo(() => {
    let isChecked = true;

    if (!additionalInfos || !httpParams) {
      return false;
    }

    if (!httpParams.studyLevel && !httpParams.sectors) {
      return false;
    }

    if (additionalInfos.educationLevels) {
      if (!httpParams.studyLevel) return false;

      const paramsEducationLevels = parseParam(httpParams.studyLevel).map(
        (e: any) => `${e}`
      );

      isChecked = additionalInfos.educationLevels.some(
        (level: string) => level === paramsEducationLevels
      );

      isChecked =
        additionalInfos.educationLevels.length ===
          paramsEducationLevels.length &&
        additionalInfos.educationLevels.every((level: string) =>
          paramsEducationLevels.includes(level)
        );

      if (isChecked === false) {
        return false;
      }
    }

    if (additionalInfos.sectors) {
      if (!httpParams.sectors) return false;

      const httpParamsSectors = parseParam(httpParams.sectors);
      const paramsSectors = httpParamsSectors.map(
        (sector: string) => `${sector}`
      );
      isChecked = additionalInfos.sectors.some(
        (sector: string) => sector === paramsSectors
      );

      isChecked =
        additionalInfos.sectors.length === paramsSectors.length &&
        additionalInfos.sectors.every((sector: string) =>
          paramsSectors.includes(sector)
        );

      if (isChecked === false) {
        return false;
      }
    }

    return isChecked;
  }, [httpParams, additionalInfos]);

  return (
    <FormControlLabel
      value="start"
      sx={{ mr: 1 }}
      control={
        <Switch
          checked={checked}
          onClick={onChange}
          // onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
          color="primary"
        />
      }
      label="Préférences d'orientation"
      labelPlacement="start"
    />
  );
};

export default AdditionalSelector;

// const Root = styled(ButtonBase)(({ theme }: any) => ({
//   border: `1px solid`,
//   fontWeight: "normal",
//   borderColor: `${theme.palette.primary.main}`,
//   borderRadius: "30px",
//   color: theme.palette.primary.main,
//   cursor: "pointer",
//   padding: "8px 16px",
//   margin: "4px",
//   fontSize: "13px",
//   fontFamily: "Product Sans",
// }));
